import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';

import { SeoBlock } from '../../../../components/SeoBlock';
import { generateSeoTitle } from '../../../../utils/helpers';
import { DEFAULT_URL } from '../../const';

interface SearchSeoBlockProps {
  tenantTitle?: string | null;
}

const SEARCH_PAGE_SEO_IMAGE = 'headers-images/5.png';

const SearchSeoBlock: FC<SearchSeoBlockProps> = ({ tenantTitle }) => {
  const { t } = useTranslation();

  return (
    <Switch>
      <Route
        path={`${DEFAULT_URL}/search`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.title'), tenantTitle),
              share_image: SEARCH_PAGE_SEO_IMAGE,
            }}
            canonicalUrl={`${DEFAULT_URL}/search`}
          />
        )}
      />
      <Route
        path={[`${DEFAULT_URL}/videos`, '/videos']}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.videos'), tenantTitle),
              seo_description: t('page.discover.videosDescription'),
            }}
            canonicalUrl={`${DEFAULT_URL}/videos`}
          />
        )}
      />
      <Route
        path={[`${DEFAULT_URL}/pathways`, '/pathways']}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.pathways'), tenantTitle),
              seo_description: t('page.discover.pathwaysDescription'),
            }}
            canonicalUrl={`${DEFAULT_URL}/pathways`}
          />
        )}
      />
      <Route
        path={`${DEFAULT_URL}/insights`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.text'), tenantTitle),
              seo_description: t('page.discover.textDescription'),
            }}
            canonicalUrl={`${DEFAULT_URL}/insights`}
          />
        )}
      />
      <Route
        path={`${DEFAULT_URL}/glossary`}
        render={() => (
          <SeoBlock
            data={{
              seo_title: generateSeoTitle(t('page.discover.glossary'), tenantTitle),
              seo_description: t('page.discover.glossaryDescription'),
            }}
            canonicalUrl={`${DEFAULT_URL}/glossary`}
          />
        )}
      />
    </Switch>
  );
};

export default SearchSeoBlock;
